import axios from 'axios'
import 'url-search-params-polyfill';
import store from '~script/store';
import TGlobal from './global';
const Base64Encode = require("js-base64").Base64.encode

let cancel;
const CancelToken = axios.CancelToken;
axios.defaults.baseURL = '/Api/'; //process.env.BASE_API
axios.defaults.timeout = 15000

// 获取url指定参数
// 返回特定值，目前用于判断是否是刷新token
// 也可稍加修改(后) 通用
const getQueryString = (url, query) => {
    let reg = new RegExp('(^|&)' + query + '=([^&]*)(&|$)'),
        qs = url.split('?')[1] ? url.split('?')[1].match(reg) : null
    return qs ? unescape(qs[2]) : null
}

// respone拦截器
axios.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob') return response
        return Promise.resolve(response.data)
    },
    error => {
        // 错误信息提示
        let errText = ''
        if (error.response) {
            if (error.response.status == 504 || error.response.status == 500) errText = "抱歉,服务器异常!"
            if (error.response.status == 401) errText = "登录已过期，请重新登录!"
            if (error.response.status == 403) errText = "抱歉,你无权访问该页面!"
            if (error.response.data && error.response.data.message) errText = error.response.data.message
        } else if (error.request) {
            if (error.message == "timeout of 15000ms exceeded") errText = "抱歉,请求超时!"
            else errText = "抱歉,系统错误!"
        } else {
            errText = "抱歉,系统错误!"
        }
        // 错误处理
        if (error.response) {
            if (error.response.status == 403) {
                window.Router.push({ path: "/403" });
            }
            return Promise.reject((error.response.status && error.response.data) || { code: 1, message: errText })
        }

        if (error.request && error.message == "timeout of 15000ms exceeded")
            return Promise.reject({ code: 1, message: errText })

        // 错误信息 返回必须用Promise.reject, 若否，则会自动进入Promise.resolve
        return Promise.reject({ code: 1, message: errText })
    }
);
const serializeArray = (object = {}) => {
    var params = new URLSearchParams();
    for (var key in object) {
        var value = object[key];
        if (Array.isArray(value)) {
            key = key + '[]';
            value.forEach(v => params.append(key, v))
        } else {
            params.append(key, value)
        }
    }
    return params;
}

function ajax(url, data = {}, params = {}, contentTypeIndex = 0, type, responsetype = '', cb) { //contentTypeIndex可传数值，代码下面数组的值,也可传字符串
    let contentTypeArr = ["application/json;charset=UTF-8", "application/x-www-form-urlencoded", "multipart/form-data"]
    //let access_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMDFLMkU1UTc2R0dNQVcwMVE1N1BFUTZNMDEiLCJ1c2VybmFtZSI6Ilx1NzUyOFx1NjIzN1x1N2FlZndsIiwidGltZXN0YW1wIjoiMjAyNS0wOS0xMCAxNjoxMToxNSIsImp3dF9pZCI6IjAxSzJFNVE3NkdHTUFXMDFRNTdQRVE2TTAxMDFLNFNBVktHMFhIRVJRRjg1MDFUQ1JZWjgifQ.zD7lSfVlBW3F7Dq2IOsaWL-zhu5a2iT9-tOB25UndZM";
    let access_token = LocalStore.get('access_token'); // "e1d922cf-eb1e-437e-b68e-21ce67b625eb";//LocalStore.get('access_token');
    //let Authorization = !access_token ? "Basic " + Base64Encode("b2b_client:b2b_client") : "Bearer " + access_token;
    // 特殊处理 刷新token 接口
    //if (getQueryString(url, 'grant_type') === 'refresh_token') Authorization = "Basic " + Base64Encode("b2b_client:b2b_client")
    let lng = vm.$i18n.locale == 'en-US' ? 'English' : 'Chinese';

    axios.defaults.headers = {
        ...HeadersIp,
        token: access_token,
        lng: lng,
        'Content-Type': contentTypeArr[contentTypeIndex]
    }


    if (TGlobal.httpTimeoutArr.indexOf(url) >= 0) {
        axios.defaults.timeout = 6000000;
    } else {
        axios.defaults.timeout = 115000;
    }

    if (contentTypeIndex === 1) {
        params = serializeArray(params);
        data = serializeArray(data);
    }

    let obj = {};
    cb && (obj.onDownloadProgress = cb);


    let responsetype1 = responsetype ? responsetype : '';

    return new Promise((resolve, reject) => {
        let cancelToken = new CancelToken(c => cancel = c);
        axios({
            method: type,
            url,
            params,
            data,
            cancelToken,
            responseType: responsetype1,
            ...obj
        }).then(res => {
            if (res.status == 209) {
                LocalStore.clearAll();
                location.reload();
            }
            // 检查API返回的token过期状态
            if (res.data && (res.data.status === 401 || res.data.code === 'TOKEN_EXPIRED' || res.data.code === 'TOKEN_REQUIRED')) {
                vm.$Message.warning('登录已过期，请重新登录');
                LocalStore.clearAll();
                store.commit('SET_ACCESS_TOKEN', '');
                store.commit('SET_USER_INFO', {});
                setTimeout(() => {
                    window.location.href = '/login';
                }, 1000);
                return reject({ code: 401, message: '登录已过期' });
            }
            return resolve(res);
        }).catch(error => {
            if (error.code == 401 && self.Router.app._route.name !== 'user') {
                vm.$Message.warning('登录已过期，请重新登录');
                LocalStore.clearAll();
                store.commit('SET_ACCESS_TOKEN', '');
                store.commit('SET_USER_INFO', {});
                setTimeout(() => {
                    window.location.href = '/login';
                }, 1000)
            }
            reject(error);
        });
    });
}

//get请求
const get = function(url, data, params, contentType, responsetype, cb) {
    return ajax(url, params, data, contentType, 'get', responsetype, cb);
};
//post请求
const post = function(url, data, params, contentType, responsetype) {
    return ajax(url, data, params, contentType, 'post', responsetype);
};
//del请求
const del = function(url, data, params, contentType) {
    return ajax(url, data, params, contentType, 'delete');
};
//put请求
const put = function(url, data, params, contentType) {
    return ajax(url, data, params, contentType, 'put');
};

export default {
    get,
    post,
    del,
    put
};